import type { Scorecard } from "@/types/analysis";

/** Static sample data for the landing page hero scorecard preview. */
export const LANDING_SAMPLE_PROJECT = "Romeo and Juliet Script";

export const LANDING_SAMPLE_LOGLINE =
  "The heirs of two feuding families fall into a forbidden love, but their secret plans to be together are shattered by violence and fate, forcing the once-obedient lovers to defy their world and find their only escape in a tragic, shared death.";

export const LANDING_SAMPLE_SYNOPSIS =
  "William Shakespeare's Romeo and Juliet is the archetypal tragic romance: two young lovers from feuding houses pursue a passionate, secret romance that ends in their deaths and finally reconciles their families. The narrative asks whether love can survive a world poisoned by inherited hatred — and answers with a devastating, cathartic sacrifice that transforms Verona forever.";

export const LANDING_SAMPLE_SCORECARD: Scorecard = {
  overall_engagement_score: 87,
  max_possible_score: 100,
  engagement_percentage: 87,
  main_genre: "Tragedy",
  logline: LANDING_SAMPLE_LOGLINE,
  etb_structure: { raw_score: 10, weighted_score: 10, max_points: 10 },
  conceptual_relevance: { raw_score: 9, weighted_score: 9, max_points: 10 },
  emotional_transformation: { raw_score: 9, weighted_score: 9, max_points: 10 },
  v7_scores: {
    story_spine_pct: 100,
    character_strength_pct: 90,
    theme_strength_pct: 70,
    commercial_viability_pct: 80,
    etb_structure_pct: 100,
    pacing_pct: 95,
    story_beat_strength_pct: 98,
    scene_strength_pct: 92,
    concentration_pct: 88,
    character_concentration_pct: 100,
    character_resonance_pct: 88,
    character_active_pct: 85,
    dialogue_strength_pct: 94,
    character_journey_pct: 90,
    thematic_quality_pct: 72,
    authenticity_pct: 68,
    genre_promise_pct: 83,
    originality_pct: 75,
    thematic_stakes_pct: 70,
    target_market_pct: 78,
  },
};
